import { ButtonProps } from '@chakra-ui/react';

import { Button } from 'shared/components/Button';

import { modal } from '.';

type ModalButtonPropTypes = {
  dataTestid?: string;
  shouldClose?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
} & ButtonProps;

export const ModalButton = ({
  children,
  onClick,
  shouldClose = true,
  dataTestid,
  ...props
}: ModalButtonPropTypes) => (
  <Button
    data-testid={dataTestid}
    onClick={(e) => {
      onClick?.(e);
      shouldClose && modal.close();
    }}
    {...props}
  >
    {children}
  </Button>
);
